// extracted by mini-css-extract-plugin
export default {"bgWhite":"Portfolio_bgWhite__Aia5w"};